
export class Termin {
    constructor(
        public type: 'client' | 'ausgleich' | 'urlaub' | 'krank' | 'uAntrag' = 'uAntrag',
        public Id = '',
        public monthIndexes: string[] = [],
        public Subject = '',
        public Description = '',
        public maId = '',
        public maIds: string[] = [],
        public maIdUmsatz: any = {},
        public maIdNoBreakfast: any = {},
        public clientId = '',
        public EndTime = '',
        public EndTimezone: any = null,
        public StartTime = '',
        public StartTimezone: any = null,
        public IsAllDay = true,
        public RecurrenceException: any = null,
        public RecurrenceID: any = null,
        public RecurrenceRule: any = null,
        public createdBy = '',
        public createdAt = '',
        public createdAtUnix = 0,
        public updatedAt = '',
        public updatedAtUnix = 0,
        public startUhrzeit = '',
        public endUhrzeit = '',
        public hotel = false,
        public hotelInfo = '',
        public anreiseAmVortag = false,
        public anschlussTermin = false,
        public deleted = false,
    ) {
    }
}
